import * as React from 'react';

export type DismissHandler = () => Promise<void>;

type ModalContextType = {
	contentRef: React.RefObject<HTMLDivElement>;
	isOnTop: boolean;
	setDismissHandler: (handler: DismissHandler) => void;
}

export const ModalContext = React.createContext<ModalContextType>({ contentRef: React.createRef<HTMLDivElement>() as unknown as any, isOnTop: false, setDismissHandler: () => { } });

export const useModalContext = () => {
	return React.useContext(ModalContext);
};

export const useIsOnTop = () => {
	const { isOnTop } = React.useContext(ModalContext);
	return isOnTop;
};

export const useOnDismiss = (handler: DismissHandler) => {

	const { setDismissHandler } = useModalContext();
	const handlerRef = React.useRef(handler);

	React.useEffect(() => {
		handlerRef.current = handler;
	}, [handler]);

	React.useEffect(() => {
		setDismissHandler(async () => await handlerRef.current());
	}, [setDismissHandler]);
};
